import React, { useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export const PROVIDER_LABEL = { pointone: 'Point One', rtkpremium: 'Premium RTK' };
export const otherProvider = (p) => (p === 'pointone' ? 'rtkpremium' : 'pointone');

// Confirms moving a GPS system or rover to the other NTRIP provider. onConfirm
// does the switch; a thrown error is shown here and the dialog stays open.
function SwitchProviderDialog({ open, unitName, provider, onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  // The card's provider changes as soon as a switch succeeds; keep the one the
  // dialog opened with so its text doesn't flip while it fades out.
  const shownProvider = useRef(provider);
  if (open && !busy) shownProvider.current = provider;
  const from = PROVIDER_LABEL[shownProvider.current];
  const to = PROVIDER_LABEL[otherProvider(shownProvider.current)];

  const handleClose = () => {
    if (busy) return;
    setError('');
    onClose();
  };

  const handleConfirm = async () => {
    setBusy(true);
    setError('');
    try {
      await onConfirm();
      setError('');
      onClose();
    } catch (err) {
      setError(err.message || 'Switch failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Switch to {to}?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          {unitName} gets new {to} credentials, and its {from} license is returned, so the current credentials stop working.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Enter the new credentials on the receiver once they show here.
        </Typography>
        {error && <Typography color="error" variant="body2" sx={{ mt: 1.5 }}>{error}</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={busy}>
          {busy ? 'Switching...' : `Switch to ${to}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SwitchProviderDialog;
